/* eslint-disable camelcase,no-continue */

import {NotixApi} from "Services/api";

class Subscriptions {
  loadSubscriptionsFilters(filters) {
    return NotixApi.get(`/subscriptions/filters?filters=${filters}`);
  }

  loadSubscriptions(limit, offset, filtersBody) {
    return NotixApi.post(
      `/subscriptions?limit=${limit}&offset=${offset}`,
      filtersBody
    );
  }

  audiencesEdit(body) {
    return NotixApi.post(`/subscriptions/audiences/edit`, body);
  }

  loadSubscriptionsCount(filtersBody) {
    return NotixApi.post(`/subscriptions/count`, filtersBody);
  }
}

const subscriptionsInstance = new Subscriptions();

export default subscriptionsInstance;